import { defineMessages } from 'react-intl';
export default defineMessages({
    addAStation: {
        id: 'stations.addAStation',
        defaultMessage: 'Add a station'
    },
    addToFavorites: {
        id: 'stations.addToFavorites',
        defaultMessage: 'Add to favorites'
    },
    addYourOwnStation: {
        id: 'stations.addYourOwnStation',
        defaultMessage: 'Add your own station'
    },
    calculatedFor: {
        id: 'stations.calculatedFor',
        defaultMessage: 'Calculated for {time} · {model}'
    },
    clearRecentLocations: {
        id: 'stations.clearRecentLocations',
        defaultMessage: 'Clear all'
    },
    currentLocation: {
        id: 'stations.currentLocation',
        defaultMessage: 'Current location'
    },
    customizedStationName: {
        id: 'stations.customizedStationName',
        defaultMessage: 'Customized station name'
    },
    favoriteLocations: {
        id: 'stations.favoriteLocations',
        defaultMessage: 'Favorites'
    },
    filterStations: {
        id: 'stations.filterStations',
        defaultMessage: 'Filter stations'
    },
    filterStationSourceDescription: {
        id: 'stations.filterStationSourceDescription',
        defaultMessage: 'Select station providers that you want to display on the map'
    },
    hideStationNamed: {
        id: 'stations.hideStationNamed',
        defaultMessage: 'Hide {station}'
    },
    hiddenStations: {
        id: 'stations.hiddenStations',
        defaultMessage: 'Hidden stations'
    },
    hiddenStationsDescription: {
        id: 'stations.hiddenStationsDescription',
        defaultMessage: 'You can unhide a station by tapping the eye icon next to it.'
    },
    lastSeen: {
        id: 'stations.lastSeen',
        defaultMessage: 'last seen {time}'
    },
    loadingStation: {
        id: 'stations.loadingStation',
        defaultMessage: 'Loading station…'
    },
    location: {
        id: 'stations.location',
        defaultMessage: 'Location'
    },
    locationAddedToFavorites: {
        id: 'stations.locationAddedToFavorites',
        defaultMessage: 'Location added to favorites'
    },
    locationNotGranted: {
        id: 'stations.locationNotGranted',
        defaultMessage: 'Location permission is not granted. Please allow access to your location in device settings.'
    },
    locationRemovedFromFavorites: {
        id: 'stations.locationRemovedFromFavorites',
        defaultMessage: 'Location removed from favorites'
    },
    locationUnavailable: {
        id: 'stations.locationUnavailable',
        defaultMessage: 'Unable to get your location. Please check your device settings.'
    },
    locations: {
        id: 'stations.locations',
        defaultMessage: 'Locations'
    },
    maxFavoriteLocationsReached: {
        id: 'stations.maxFavoriteLocationsReached',
        defaultMessage: 'You can only have up to 5 favorite locations. Remove one to add another.'
    },
    modifyFavoriteStations: {
        id: 'stations.modifyFavoriteStations',
        defaultMessage: 'Modify favorite stations'
    },
    modifyFavoriteStationsDescription: {
        id: 'stations.modifyFavoriteStationsDescription',
        defaultMessage: 'You can reorder your favorite stations by dragging them. You can also remove them from the list.'
    },
    useMyLocation: {
        id: 'stations.useMyLocation',
        defaultMessage: 'Use my location'
    },
    browserLocationUnavailable: {
        id: 'stations.browserLocationUnavailable',
        defaultMessage: "Your location couldn't be found. Check that your browser allows this site to use it, then try again."
    },
    approximateLocationUnavailable: {
        id: 'stations.approximateLocationUnavailable',
        defaultMessage: "Approximate location isn't available. Tap to allow precise location."
    },
    allowPreciseLocation: {
        id: 'stations.allowPreciseLocation',
        defaultMessage: 'Allow precise location'
    },
    myStations: {
        id: 'stations.myStations',
        defaultMessage: 'My stations'
    },
    myWeather: {
        id: 'stations.myWeather',
        defaultMessage: 'My weather'
    },
    backToPlace: {
        id: 'stations.backToPlace',
        defaultMessage: 'Back to {place}'
    },
    backToCurrentLocation: {
        id: 'stations.backToCurrentLocation',
        defaultMessage: 'Back to current location'
    },
    myWeatherIntroTitle: {
        id: 'stations.myWeatherIntroTitle',
        defaultMessage: 'Stations and places, one list'
    },
    myWeatherIntroBody: {
        id: 'stations.myWeatherIntroBody',
        defaultMessage: 'Your stations stay at the top. Search now finds towns and stations.'
    },
    myWeatherIntroOk: {
        id: 'stations.myWeatherIntroOk',
        defaultMessage: 'OK'
    },
    editMyWeather: {
        id: 'stations.editMyWeather',
        defaultMessage: 'Edit My weather'
    },
    myWeatherItemActions: {
        id: 'stations.myWeatherItemActions',
        defaultMessage: 'Actions for {name}'
    },
    removedFromMyWeather: {
        id: 'stations.removedFromMyWeather',
        defaultMessage: '{name} removed'
    },
    undoRemove: {
        id: 'stations.undoRemove',
        defaultMessage: 'Undo'
    },
    removeFromMyWeatherFailed: {
        id: 'stations.removeFromMyWeatherFailed',
        defaultMessage: 'Couldn’t remove {name}'
    },
    hiddenFromMyWeather: {
        id: 'stations.hiddenFromMyWeather',
        defaultMessage: '{name} hidden'
    },
    shownInMyWeather: {
        id: 'stations.shownInMyWeather',
        defaultMessage: '{name} shown again'
    },
    searchPlaceOrStation: {
        id: 'stations.searchPlaceOrStation',
        defaultMessage: 'Search for a place or station'
    },
    places: {
        id: 'stations.places',
        defaultMessage: 'Places'
    },
    showAllStations: {
        id: 'stations.showAllStations',
        defaultMessage: 'Show all {count}'
    },
    placeSearchFailed: {
        id: 'stations.placeSearchFailed',
        defaultMessage: 'Couldn’t load places'
    },
    stationSearchFailed: {
        id: 'stations.stationSearchFailed',
        defaultMessage: 'Couldn’t load stations'
    },
    moreStationsFailed: {
        id: 'stations.moreStationsFailed',
        defaultMessage: 'Couldn’t load more stations'
    },
    searchTryAgain: {
        id: 'stations.searchTryAgain',
        defaultMessage: 'Try again'
    },
    noPlaceFound: {
        id: 'stations.noPlaceFound',
        defaultMessage: 'No place found'
    },
    noStationNamed: {
        id: 'stations.noStationNamed',
        defaultMessage: 'No station named “{query}”'
    },
    searchSummary: {
        id: 'stations.searchSummary',
        defaultMessage: '{places, plural, one {# place} other {# places}}, {stations, plural, one {# station} other {# stations}}'
    },
    myLocation: {
        id: 'stations.myLocation',
        defaultMessage: 'My location'
    },
    nearbyWeatherStations: {
        id: 'stations.nearbyWeatherStations',
        defaultMessage: 'Nearby weather stations'
    },
    noLocationsFound: {
        id: 'stations.noLocationsFound',
        defaultMessage: 'No locations found'
    },
    noLongerReported: {
        id: 'stations.noLongerReported',
        defaultMessage: 'No longer reported'
    },
    noLongerReportedBy: {
        id: 'stations.noLongerReportedBy',
        defaultMessage: 'No longer reported by {provider} since {date}'
    },
    noSearchResults: {
        id: 'stations.noSearchResults',
        defaultMessage: 'No articles match your search'
    },
    noStationsFound: {
        id: 'stations.noStationsFound',
        defaultMessage: 'No Stations Found'
    },
    noWeatherStationYet: {
        id: 'stations.noWeatherStationYet',
        defaultMessage: "You don't have a weather station yet."
    },
    recentLocations: {
        id: 'stations.recentLocations',
        defaultMessage: 'Recent'
    },
    removeFromFavorites: {
        id: 'stations.removeFromFavorites',
        defaultMessage: 'Remove from favorites'
    },
    removeStationNamed: {
        id: 'stations.removeStationNamed',
        defaultMessage: 'Remove {station} from favorites'
    },
    reorderStationNamed: {
        id: 'stations.reorderStationNamed',
        defaultMessage: 'Reorder {station}'
    },
    searchForLocation: {
        id: 'stations.searchForLocation',
        defaultMessage: 'Search for a location'
    },
    findingYourLocation: {
        id: 'stations.findingYourLocation',
        defaultMessage: 'Finding your location…'
    },
    noLocationTitle: {
        id: 'stations.noLocationTitle',
        defaultMessage: 'Where do you want the weather?'
    },
    searchForWeatherStation: {
        id: 'stations.searchForWeatherStation',
        defaultMessage: 'Search for a weather station'
    },
    searchResultsFound: {
        id: 'stations.searchResultsFound',
        defaultMessage: '{count, plural, one {# result found} other {# results found}}'
    },
    selectStationForComparison: {
        id: 'stations.selectStationForComparison',
        defaultMessage: 'Select a station to compare with'
    },
    stationAddedToFavorites: {
        id: 'stations.stationAddedToFavorites',
        defaultMessage: 'Station added to favorites'
    },
    stationInformation: {
        id: 'stations.stationInformation',
        defaultMessage: 'Station information'
    },
    stationName: {
        id: 'stations.stationName',
        defaultMessage: 'Station name'
    },
    stationObservationsDescription: {
        id: 'stations.stationObservationsDescription',
        defaultMessage: 'Display the latest observations from weather stations'
    },
    stationRemovedFromFavorites: {
        id: 'stations.stationRemovedFromFavorites',
        defaultMessage: 'Station removed from favorites'
    },
    stationsLoading: {
        id: 'stations.stationsLoading',
        defaultMessage: 'Loading weather stations'
    },
    stationType: {
        id: 'stations.stationType',
        defaultMessage: 'Station type'
    },
    statusOffline: {
        id: 'stations.statusOffline',
        defaultMessage: 'Offline'
    },
    statusOnline: {
        id: 'stations.statusOnline',
        defaultMessage: 'Online'
    },
    statusStale: {
        id: 'stations.statusStale',
        defaultMessage: 'Stale'
    },
    unhideStationNamed: {
        id: 'stations.unhideStationNamed',
        defaultMessage: 'Unhide {station}'
    },
    weatherStation: {
        id: 'stations.weatherStation',
        defaultMessage: 'Weather station'
    },
    weatherStations: {
        id: 'stations.weatherStations',
        defaultMessage: 'Weather stations'
    },
    welcomeConnectService: {
        id: 'stations.welcomeConnectService',
        defaultMessage: 'Own a weather station? Connect your service'
    },
    welcomeSubtitle: {
        id: 'stations.welcomeSubtitle',
        defaultMessage: 'Your weather, all in one place'
    }
});
